import React from 'react';
import Link from 'gatsby-link';

import '../scss/footer.scss';

export default function Header({ children, className, to }) {
  return (
    <footer className="footer">
      <div className="content">
        denisborodin.com © 2015–{new Date().getFullYear()}
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/components/Footer.js